import { useState, useEffect, useRef, useCallback } from "react";
import { getOrders } from "../../api/orders";
import { OrderDetailed } from "../../components/orderDetailed";
import "./style.css";

export const Orders = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const inFlight = useRef(false);
  const mounted = useRef(false);

  const query = useCallback(async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    if (mounted.current) setLoading(true);
    try {
      const response = await getOrders({});
      if (!response || response.error || !Array.isArray(response.data)) {
        throw new Error("Invalid delivery queue response");
      }
      if (mounted.current) {
        setData(response.data);
        setError(false);
      }
    } catch {
      if (mounted.current) setError(true);
    } finally {
      inFlight.current = false;
      if (mounted.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    query();
    const interval = setInterval(query, 10000);
    return () => {
      mounted.current = false;
      clearInterval(interval);
    };
  }, [query]);

  return (
    <div className="ordersContainer" aria-busy={loading}>
      {error ? (
        <div className="order-dataValue p-4">
          <p role="alert">No se pudieron cargar los pedidos. Comprueba tu conexión y vuelve a intentarlo. Si tu sesión ha caducado, inicia sesión de nuevo.</p>
          <button type="button" onClick={query} disabled={loading}>
            {loading ? "Reintentando…" : "Reintentar"}
          </button>
        </div>
      ) : loading && data.length === 0 ? (
        <div className="order-dataValue p-4" role="status">Cargando pedidos…</div>
      ) : data.length === 0 ? (
        <div className="order-dataValue p-4" role="status">No tienes pedidos pendientes de entregar</div>
      ) : (
        data.map((order) => <OrderDetailed key={order.orderId} data={order} refreshOrders={query} />)
      )}
    </div>
  );
};
